import type { Service } from './schema'
import { tools } from './tools'

export const servicesPage = {
  eyebrow: 'Services',
  title: 'What I take off your plate.',
  lede: 'One person who understands the whole HighLevel account, from the first form field to the last follow-up.',
}

/**
 * The Home Services section: a stack of cards dealt onto a pile as the page scrolls. The display line
 * is the thin + bold pair below.
 */
export const servicesSection = {
  eyebrow: servicesPage.eyebrow,
  titleThin: 'Five ways',
  titleBold: 'I can help.',
  explore: 'See the work',
  /** The Work chapter each card opens, by service id (a chapter id from home.ts). */
  work: {
    crm: 'automations',
    workflows: 'automations',
    'voice-ai': 'automations',
    campaigns: 'automations',
    support: 'automations',
  } as Record<string, string>,
}

export const services: Service[] = [
  {
    id: 'crm',
    title: 'CRM setup and management',
    summary: 'Complete HighLevel configuration, pipelines and ongoing management.',
    outcome: 'Foundation',
    bullets: ['Pipelines and stages that match your sales', 'Custom fields, tags and forms', 'Calendars and booking set up right'],
    tools: [tools.gohighlevel, tools.pipelines, tools.calendars],
  },
  {
    id: 'workflows',
    title: 'Workflows and automation',
    summary: 'Automated workflows that streamline how your business runs.',
    outcome: 'Most requested',
    bullets: ['Lead routing and follow-up', 'Reminders, tasks and handoffs', 'Tested on every branch before launch'],
    tools: [tools.gohighlevel, tools.workflows, tools.aiAutomation],
  },
  {
    id: 'voice-ai',
    title: 'Voice AI and AI automation',
    summary: 'AI agents and automations that answer, qualify and route.',
    outcome: 'AI',
    bullets: ['Voice AI that answers any hour', 'AI-personalised nurture', 'WhatsApp IVR routing'],
    tools: [tools.gohighlevel, tools.voiceAi, tools.whatsapp],
  },
  {
    id: 'campaigns',
    title: 'Email and SMS campaigns',
    summary: 'Setting up and managing campaigns people actually read.',
    outcome: 'Nurture',
    bullets: ['Nurture and re-engagement sequences', 'AI-written emails in your voice', 'Timed so it never feels spammy'],
    tools: [tools.gohighlevel, tools.emailSms, tools.aiAutomation],
  },
  {
    id: 'support',
    title: 'Support, docs and client success',
    summary: 'Troubleshooting, documentation and keeping your clients happy.',
    outcome: 'Ongoing',
    bullets: ['Fix broken workflows and funnels', 'Clear system documentation', 'Smooth client onboarding'],
    tools: [tools.gohighlevel, tools.googleWorkspace, tools.workflows],
  },
]
